import { Col, Row } from "reactstrap";
import { Form } from "react-final-form";
import React, { useState } from "react";
import axios from "axios";
import { connect } from "react-redux";

import TemplateButton from "@/shared/components/TemplateButton";
import DatePicker from "react-datepicker";

import {getFirstDay} from '@/shared/helpers'
import {dateStrToYmd} from '@/shared/helpers';

import {
  useDispatch,
  flashError,
  flashSuccess,
} from "@/shared/components/flash";

const defaultFrom = getFirstDay()
const defaultTo = new Date()

const InvoiceSummaryForm = ({
  rootProgram,
  toggle,
  auth,
  program,
  btnLabel = "Summary PDF",
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const [from, setFrom] = React.useState(defaultFrom)
  const [to, setTo] = React.useState(defaultTo)

  const onSubmitFilter = async (values) => {
    setLoading(true);
    let start_date = dateStrToYmd( from)
    let end_date = dateStrToYmd(to)
    axios.post(`/organization/${program.organization_id}/program/${program.id}/invoice-summary/download`,
      {
        start_date: start_date,
        end_date: end_date
      },
      {
        responseType: 'arraybuffer',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/pdf'
        }, 
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Invoice-Summary.pdf`); //or any other extension
        document.body.appendChild(link);
        link.click();
        setLoading(false);
        flashSuccess(dispatch, "Invoice Summary downloaded!");
      })
      .catch((err) => {
        flashError(dispatch, err.response.data);
        setLoading(false);
      });
  };

  const onStartChange = (value) => {
    setFrom(value)
  }
  const onEndChange = (value) => {
    setTo(value)
  }
  return (
    <Form onSubmit={onSubmitFilter} >
      {({ handleSubmit, form, submitting, pristine, values }) => (
        <form
          className="form d-flex flex-column"
          onSubmit={handleSubmit}
        >
          <Row>
            <Col md="6">
              <div className="form__form-group">
                <span className="form__form-group-label">From</span>
                <div className="form__form-group-field">
                  <div className="form__form-group-row">
                      <DatePicker
                        name="start_date"
                        dateFormat="MM/dd/yyyy"
                        selected={from}
                        onChange={onStartChange}
                        popperProps={{ strategy: "fixed" }}
                      />
                  </div>
                </div>
              </div>
            </Col>
            <Col md="6">
                <div className="form__form-group">
                <span className="form__form-group-label">To</span>
                <div className="form__form-group-field">
                    <div className="form__form-group-row">
                      <DatePicker
                        name="end_date"
                        dateFormat="MM/dd/yyyy"
                        selected={to}
                        onChange={onEndChange}
                        popperProps={{ strategy: "fixed" }}
                      />
                    </div>
                </div>
                </div>
            </Col>
            </Row>
            <Row>
            <Col md="12" align={'center'} >
              <br/>
               <TemplateButton disabled={loading} type="submit" text={btnLabel} />
            </Col>
          </Row>
        </form>
      )}
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    program: state.program,
    rootProgram: state.rootProgram,
  };
};

export default connect(mapStateToProps)(InvoiceSummaryForm);
